import { render, staticRenderFns } from "./MassifList.vue?vue&type=template&id=a1261ed2&scoped=true"
import script from "./MassifList.vue?vue&type=script&lang=js"
export * from "./MassifList.vue?vue&type=script&lang=js"
import style0 from "./MassifList.vue?vue&type=style&index=0&id=a1261ed2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1261ed2",
  null
  
)

export default component.exports